import timeutils from 'utils/wt-time-utils'
import { cashCount } from '@/utils/formUtils'
export default {
  cpsPaymentList (data) {
    data.forEach(item => {
      item.pay_date = item.payDate && timeutils.format(item.payDate)
      item.amount = item.payAmount && cashCount(item.payAmount, true, 2)
      item.birth_date = item.birthday && timeutils.format(item.birthday, 'date')
    })
    return data
  }
}
